// useRealtimePrices.js
import { useEffect, useRef, useState } from "react";
import { onMarketMessage } from "../../src/ws/marketWs";
import { latestPrices } from "../../src/store/marketPrices";
import api from "../services/api";

export const useRealtimePrices = () => {
    const [prices, setPrices] = useState({ ...latestPrices });
    const bufferRef = useRef({});
    const lastSentRef = useRef({});
    const updatingRef = useRef(false);

    const updatePricesInDB = async (snapshot) => {
        if (updatingRef.current) return;

        const payload = [];

        for (const [symbol, data] of Object.entries(snapshot)) {

            if (lastSentRef.current[symbol] !== data.price) {

                payload.push({
                    symbol,
                    ltp: data.price
                });

                lastSentRef.current[symbol] = data.price;
            }
        }

        if (payload.length === 0) return;

        updatingRef.current = true;

        try {

            await api.put("/update-ltp-bulk", payload);

        } catch (err) {

            console.error("DB update failed", err);

        } finally {

            updatingRef.current = false;

        }
    };

    useEffect(() => {
        const unsubscribe = onMarketMessage((msg) => {
            // ✅ Handle v2 format
            if (msg?.type?.toLowerCase() !== "price") return;
            const data = msg.data;
            if (!data) return;

            const { symbol,token, value: price, close: prevClose, open } = data;
            if (!token || price == null) return;

            const prev = bufferRef.current[token] || latestPrices[token];
            const base = prev?.prevClose ?? prevClose ?? open ?? prev?.price ?? price;

            const newPriceData = {
                price,
                prevClose: base,
                change: price - base,
                changePercent: base ? ((price - base) / base) * 100 : 0,
                __ui_ts: Date.now(), // for flash
            };
            bufferRef.current[token] = newPriceData;

            // Update global cache immediately (so other screens get fresh data)
            latestPrices[token] = newPriceData;
        });

        const flush = setInterval(() => {
            const snapshot = { ...bufferRef.current };
            if (Object.keys(snapshot).length > 0) {
                bufferRef.current = {};
                setPrices(prev => ({ ...prev, ...snapshot }));
                // updatePricesInDB(snapshot)
            }
        }, 400);

        return () => {
            unsubscribe?.();
            clearInterval(flush);
        };
    }, []);

    return { prices };
};

export default useRealtimePrices;